/* Game of Nuts theme: live search suggestions in the header. No dependencies. */
(() => {
  'use strict';
  const qs = (s, r = document) => r.querySelector(s);

  const init = () => {
    const panel = qs('[data-search-panel]');
    if (!panel) return;
    const input = qs('input[type="search"]', panel);
    const box = qs('[data-predictive]', panel);
    if (!input || !box) return;

    let timer, controller;
    const hide = () => { box.hidden = true; box.innerHTML = ''; };

    const run = async () => {
      const q = input.value.trim();
      if (q.length < 2) return hide();
      if (controller) controller.abort();
      controller = new AbortController();
      const base = (window.GON && GON.routes && GON.routes.suggest) || '/search/suggest';
      const url = `${base}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last&section_id=predictive-search`;
      try {
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) return hide();
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const results = qs('[data-predictive-results]', doc);
        if (results && results.innerHTML.trim()) { box.innerHTML = results.innerHTML; box.hidden = false; }
        else hide();
      } catch (err) { if (err.name !== 'AbortError') hide(); }
    };

    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 250); });
    input.addEventListener('focus', () => { if (input.value.trim().length >= 2) run(); });
    document.addEventListener('click', (e) => { if (!panel.contains(e.target) && !e.target.closest('[data-search-toggle]')) hide(); });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
